module.exports = __webpack_public_path__ + "img/staff.5ca84949.svg";